import { IIsiDtoIwsAssociatedViewClientState } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPlAssociatedViewManagerRequest, IsiDtoPlAssociatedViewManagerResponse, IsiDtoPlAssociatedViewManagerResult, IsiDtoPlAssociatedViewUpdateXmlJoinRequest } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlAssociatedViewManager";
import { IIsiUIFlowResult } from "../Core/IIsiUIFlowResult";
import { IsiPresentationLogic } from "./IsiPresentationLogic";

export class IsiPlAssociatedViewManager extends IsiPresentationLogic {

    constructor() {
        super("IsiPlAssociatedViewManagerHandler");
    }

    /**
     * Mets à jour l'état client de la grille côté server
     * Permet notamment de descendre les lignes sélectionnées... pour qu'elles soient prisent en compte dans une action 
     * sans repostage complet de la page
     * @param clientState
     * @returns
     */
    public async uploadClientState(clientState: IIsiDtoIwsAssociatedViewClientState): Promise<IIsiUIFlowResult> {
        const request = IsiDtoPlAssociatedViewManagerRequest.fromJS({
            clientState: clientState,
            response: IsiDtoPlAssociatedViewManagerResponse.fromJS({
                clientStateResult: IsiDtoPlAssociatedViewManagerResult.fromJS({})
            })
        });

        try {
            await this.ajax("SetClientState", request, true);
            return { result: true, continue: false };
        } catch (error) {
            return Promise.reject<IIsiUIFlowResult>(null);
        }
    }
    /**
     * Met à jour le lien d'une donnée associée en fonction de ses controles liés.
     * @param associatedViewCtxId identifiant du context de la donnée associée.
     * @param ctrlsValuess liste des controles/valeur permettant de mettre à jour le lien.
     * @returns
     */
    public async updateCtrlJoin(associatedViewCtxId: string, ctrlsValues: Map<string, string>): Promise<IIsiUIFlowResult> {
        let ctrlVals = {};
        ctrlsValues.forEach((val, key) => {
            ctrlVals[key] = val;
        })

        const request = IsiDtoPlAssociatedViewManagerRequest.fromJS({
            updateXmlJoinRequest: IsiDtoPlAssociatedViewUpdateXmlJoinRequest.fromJS({
                associatedViewContextId: associatedViewCtxId,
                clientCtrlsValues: ctrlVals
            }),
            response: IsiDtoPlAssociatedViewManagerResponse.fromJS({
                clientStateResult: IsiDtoPlAssociatedViewManagerResult.fromJS({})
            })
        });

        const result = await this.ajaxWithErrorHandling("UpdCtrlsValueForJoin", request, true);
        return result;

    }

    /**
    * Met à jour la DA ouverte côté server
    */
    public async uploadShownContextId(shownContextId: string): Promise<IIsiUIFlowResult> {
        const request = IsiDtoPlAssociatedViewManagerRequest.fromJS({
            shownContextId: shownContextId,
            response: IsiDtoPlAssociatedViewManagerResponse.fromJS({
                clientStateResult: IsiDtoPlAssociatedViewManagerResult.fromJS({})
            })
        });

        try {
            await this.ajax("SetShownContextId", request, true);
            return { result: true, continue: false };
        } catch (error) {
            return Promise.reject<IIsiUIFlowResult>(null);
        }
    }

}
